var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "w-row",
        [
          _c("w-select", {
            staticClass: "mr",
            attrs: { items: _vm.yearSelectItems },
            on: {
              input: function ($event) {
                return _vm.setYear($event)
              },
            },
            model: {
              value: _vm.year,
              callback: function ($$v) {
                _vm.year = $$v
              },
              expression: "year",
            },
          }),
          _c("w-select", {
            attrs: { items: _vm.modeSelectItems, value: _vm.mode },
            on: {
              input: function ($event) {
                return _vm.setMode($event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }